import { useEffect } from 'react';
import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import AudienceSplitSection from './components/AudienceSplitSection';
import AboutSection from './components/AboutSection';
import AudienceBandHeader from './components/AudienceBandHeader';
import CoursesSection from './components/CoursesSection';
import CurriculumSection from './components/CurriculumSection';
import BenefitsSection from './components/BenefitsSection';
import FacilityAccessSection from './components/FacilityAccessSection';
import NewsSection from './components/NewsSection';
import HomeFAQSection from './components/HomeFAQSection';
import CorporateSection from './components/CorporateSection';
import FinalCTASection from './components/FinalCTASection';
import Seo from '@/components/seo/Seo';

export default function HomePage() {
  useEffect(() => {
    // Scroll-triggered fade-in animation using Intersection Observer
    const observerOptions = {
      root: null,
      rootMargin: '0px 0px -60px 0px',
      threshold: 0.1,
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
        }
      });
    }, observerOptions);

    const sections = document.querySelectorAll('.fade-in-section');
    sections.forEach((section) => observer.observe(section));

    return () => observer.disconnect();
  }, []);

  return (
    <>
      <Seo route="/" />
      <Header />
      <main>
        <HeroSection />
        <div className="fade-in-section">
          <NewsSection />
        </div>
        <div className="fade-in-section">
          <AudienceSplitSection />
        </div>
        <div className="fade-in-section">
          <AboutSection />
        </div>
        <div className="fade-in-section">
          <AudienceBandHeader variant="personal" />
        </div>
        <div className="fade-in-section">
          <CoursesSection />
        </div>
        <div className="fade-in-section">
          <CurriculumSection />
        </div>
        <div className="fade-in-section">
          <BenefitsSection />
        </div>
        <div className="fade-in-section">
          <FacilityAccessSection />
        </div>
        <div className="fade-in-section">
          <AudienceBandHeader variant="corporate" />
        </div>
        <div className="fade-in-section">
          <CorporateSection />
        </div>
        <div className="fade-in-section">
          <HomeFAQSection />
        </div>
        <div className="fade-in-section">
          <FinalCTASection />
        </div>
      </main>
      <Footer />
    </>
  );
}